// Save as: src/TemplateBuilder/DataCatalogPanel.js
//
// Reads whatever backend/metadata/entityCatalog.js returns from GET /template-catalog
// and renders it as a clickable/draggable field tree. Clicking a field inserts
// {{Entity.Field}} into the currently-selected text block (handled by the parent).

import React, { useState } from 'react';

const DataCatalogPanel = ({ catalog, onFieldClick }) => {
  const [openEntity, setOpenEntity] = useState(null);

  return (
    <div>
      <div style={{ fontWeight: 'bold', margin: '12px 0 6px' }}>Data fields</div>
      {Object.entries(catalog).map(([entityName, def]) => (
        <div key={entityName} style={{ marginBottom: 4 }}>
          <div
            onClick={() => setOpenEntity(openEntity === entityName ? null : entityName)}
            style={{ cursor: 'pointer', fontWeight: 600, fontSize: 13, padding: '4px 0' }}
          >
            {openEntity === entityName ? '\u25be' : '\u25b8'} {def.label || entityName}
          </div>
          {openEntity === entityName && (
            <div style={{ paddingLeft: 12 }}>
              {(def.fields || []).map((field) => (
                <div
                  key={field}
                  draggable
                  onDragStart={(e) => e.dataTransfer.setData('text/plain', `${entityName}.${field}`)}
                  onClick={() => onFieldClick(`${entityName}.${field}`)}
                  title={`Insert ${entityName}.${field}`}
                  style={{ fontSize: 12, padding: '2px 0', cursor: 'pointer', color: '#444' }}
                >
                  {field}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default DataCatalogPanel;
